export default __webpack_public_path__ + "static/media/rank-4.e924980f.svg";